import { Component, OnInit, Renderer, ViewChild, Input } from '@angular/core';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AdminService } from '../services/admin';
import { Agent_Mef } from 'model/modal-cms/aget_mef';
import { Popup } from 'ng2-opd-popup';
import { CMSService } from '../services/cms-service';
import { Epidemimie } from 'model/modal-cms/epidemie';
import { environment } from 'environments/environment';
import { NgbdModalContent_olde } from './modal/modal.component';

@Component({
  selector: 'app-components',
  templateUrl: './components.component.html',
  styles: [`
    ngb-progressbar {
        margin-top: 5rem; 
    }
    `]
})

export class ComponentsComponent implements OnInit {
  page = 4;
  page1 = 5;
  focus;
  focus1;
  focus2;
  date: { year: number, month: number };
  pdfSrc: string = "assets/file/attrubition_cms.pdf";
  mode_daf: number = 1;
  nombre_visiteur: any;
   Nombre_des_visiteurs : any;
  model: NgbDateStruct;
  mode_chef: number = 1;
  mode_daf2: number;
  mode_btn: number = 1;
  mode_chef2: number;
  mode_btn_chef: number = 1;
  agent_Mef: Agent_Mef;
  nbr_covid19: any;
  @ViewChild('popup5') popup5: Popup;
  epidemimie: Epidemimie = new Epidemimie(null);
  mot_defil: any;
  date_covid19: any;
  infoIec: any;
  urllogoIec = environment.urllogoIec;
  nbr_quest_en_attante: any;
  nbr_bc_en_attante_by_direction : any;

  //********update 26 oct 2021********

      title_of_popup_info_actu :any  = "Journée mondial du Diabète";
      couleur_popup_new_actu : any =  "#064a50";



  @Input()
  public alerts: Array<IAlert> = [];
  private backup: Array<IAlert>;
  loginuserCMSActuel: any;
  statistique_actu : any ;

  constructor(private modalService: NgbModal, private router: Router, private renderer: Renderer, public adminService: AdminService, public cmsService: CMSService, ) {
    // console.log("spootv000 ");
    // this.adminService.newCribSubect_message_user.subscribe(
    //   data => {
    //     console.log("spoot " + data);
    //       this.nbr_quest_en_attante = data; 
    //       if (this.nbr_quest_en_attante != 0) {
    //         this.alerts.push({
    //           id: 1,
    //           type: 'danger',
    //           message: 'Vous avez réçus de nouveau message(s)',
    //           icon: 'nc-bell-55'
    //         });
    //         this.backup = this.alerts.map((alert: IAlert) => Object.assign({}, alert));    

    //       }          
    //   }
    // ); 


    this.adminService.newCribSubect_login_user_cms.subscribe(
      data => {
        this.loginuserCMSActuel = data
        console.log("corona covide" + this.loginuserCMSActuel);
      }
    );
  }

  isWeekend(date: NgbDateStruct) {    
    // this.nbr_covid19 = this.adminService.getevolution_epidemie_actuel();
    const d = new Date(date.year, date.month - 1, date.day);
    return d.getDay() === 0 || d.getDay() === 6;



  }

  isDisabled(date: NgbDateStruct, current: { month: number }) {
    return date.month !== current.month;

  }

  ngOnInit() {
    let input_group_focus = document.getElementsByClassName('form-control');
    let input_group = document.getElementsByClassName('input-group');
    for (let i = 0; i < input_group.length; i++) {
      input_group[i].children[0].addEventListener('focus', function () {
        input_group[i].classList.add('input-group-focus');
      });
      input_group[i].children[0].addEventListener('blur', function () {
        input_group[i].classList.remove('input-group-focus');
      });
    };
    //  this.agent_Mef = this.adminService.getUserIscrit();
    this.getnombrevisiteur();
    this.getinfoipdemie();
    this.getmot_defil();
    this.getIecFile();

    // if(this.loginuserCMSActuel == "com_daf"){

    // }

    this.getnombreQuestionEnAttante();
    this.getnombreBcByDrirection();



    // this.adminService.newCribSubect_evolution_epidemie.subscribe(
    //   data => {
    //       this.nbr_covid19=data   


    //   }
    // );    



  }


  open22(id: any) {
    this.adminService.setUserId(id);
    console.log(id)
    const modalRef = this.modalService.open(NgbdModalContent_olde);
    modalRef.componentInstance.name = 'modal-content';
   
  }


  getIecFile() {
    this.cmsService.getIecAcc("F")
      .subscribe(data => {
        this.infoIec = data
      },
        err => {
          console.log(err);
        })
  }



  getmot_defil() {
    this.adminService.getmot_defil_by_etat("ACTU")
      .subscribe(data => {
        this.mot_defil = data.contenue_mot;
      }, err => {

      })
  }


  getnombrevisiteur() {
    this.adminService.getnombrevisiteur()
      .subscribe(data => {
        this.nombre_visiteur = data;
        this.Nombre_des_visiteurs = "Nombre des visiteurs";
      }, err => {

      })
  }



  details_(id: any) {
    let etat = "F"
    this.router.navigate(['detail-iec/' + id + "/" + etat]);

  }

  details(id: any, etat_:any) {
    if (id == 41) {
      this.router.navigate(['landing']);
    }else  if (id == 145) {
      this.router.navigate(['geste-barr']);
    } else {
      let etat = "F"
      this.router.navigate(['detail-iec/' + id + "/" + etat]);
    }

  }


  open_daf(id: any) {
    if (id == 1) {
      this.mode_daf2 = 1
      this.mode_btn = 2
    } else {
      this.mode_daf2 = 2
      this.mode_btn = 1
    }
  }

  open(id: any) {
    if (id == 1) {
      this.mode_chef2 = 1
      this.mode_btn_chef = 2
    } else {
      this.mode_chef2 = 2
      this.mode_btn_chef = 1
    }
  }

  information() {
    this.router.navigate(['contact']);
  }


  
   popupnew_olde() {
    this.popup5.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-danger",
      color: "#FF0000",
      showButtons: true,
      animationDuration: 2,
      header: "ALERT COVID-19",
      widthProsentage: 50,
      animation: "fadeInDown",
      confirmBtnContent: "En savoir plus",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);

  }

  popupnew() {
    this.popup5.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: this.couleur_popup_new_actu,
      showButtons: true,
      animationDuration: 2,
      header: this.title_of_popup_info_actu,
      widthProsentage: 50,
      animation: "fadeInUp",
      confirmBtnContent: "En savoir plus",
      cancleBtnContent: "Fermer",
    }
    this.popup5.show(this.popup5.options);

  }


 


   getinfoipdemie() {
    let etat = "ARTICLE"
    this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
      .subscribe(data => {
        this.epidemimie = data
        this.nbr_covid19 = this.epidemimie.text_epid
        this.date_covid19 = this.epidemimie.date_ajout
        if(this.epidemimie.image_actu == null){
         // ************atao dynamique************ 
          this.statistique_actu = "diabete7.jpg";
          this.popupnew();         
        }else{ 
          this.statistique_actu = this.epidemimie.image_actu;
         // this.statistique_actu = "diabete7.jpg";
          this.popupnew();
        }
      },
        err => {
          console.log(err);
        })
  }


   getinfoipdemie_olde() {
    let etat = "ACTU"
    this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
      .subscribe(data => {
        this.epidemimie = data
        this.nbr_covid19 = this.epidemimie.text_epid
        this.date_covid19 = this.epidemimie.date_ajout
        if(this.epidemimie.image_actu == null){        
          this.statistique_actu = "alerte_corona.PNG";
          this.popupnew();         
        }else{
          this.statistique_actu = this.epidemimie.image_actu;
          this.popupnew();
        }
      },
        err => {
          console.log(err);
        })
  }





  voir_() {
    let etat = "F"
    this.router.navigate(['detail-iec/' + 1 + "/" + etat]);
  }

  voir_olde() {   
    if(this.adminService.getLoginUseCMS() == "com_daf"){
       this.router.navigate(['iec-epidemie']);
    }else{
     
       this.router.navigate(['landing']);
    }
  }

  
  voir() {   
    if(this.adminService.getLoginUseCMS() == "com_daf"){
       this.router.navigate(['article']);
    }else{     
       this.router.navigate(['article']);
    }
  }


  //set question
  getnombreQuestionEnAttante() {
    this.adminService.getnombreQuestionEnAttante("c")
      .subscribe(data => {
        this.nbr_quest_en_attante = data;
        console.log("  this.nbr_quest_en_attante = data;" + data)

        console.log("corona covide" + this.adminService.getLoginUseCMS());
        if (this.nbr_quest_en_attante != 0 && this.adminService.getLoginUseCMS() == "com_daf") {          //   info_message3.show();   

          this.alerts.push({
            id: 1,
            type: 'danger',
            message: 'Vous avez réçus de nouveau message(s)',
            icon: 'nc-bell-55'
          });
          this.backup = this.alerts.map((alert: IAlert) => Object.assign({}, alert));

        }else{
          console.log("Amizao" )
        }
      }, err => {

      })
  }


  //set nombre BC par direction
   getnombreBcByDrirection() {
    this.adminService.getnombreBCEnAttanteByDirection("DAF","A")
      .subscribe(data => {
        this.nbr_bc_en_attante_by_direction = data;
        console.log(" this.nbr_bc_en_attante_by_direction = data;" + data)
        if (this.nbr_bc_en_attante_by_direction != 0 && this.adminService.getLoginUseCMS() == "val_bc") {          //   info_message3.show();   

          this.alerts.push({
            id: 1,
            type: 'danger',
            message: 'Nouveau BC',
            icon: 'nc-bell-55'
          });
          this.backup = this.alerts.map((alert: IAlert) => Object.assign({}, alert));

        }else{
          console.log("Amizao" )
        }
      }, err => {

      })
  }





  public closeAlert(alert: IAlert) {
    const index: number = this.alerts.indexOf(alert);
    this.alerts.splice(index, 1);
  }



}


export interface IAlert {
  id: number;
  type: string;
  message: string;
  icon?: string;
}





// $db['default'] = array(
// 	'dsn'	=> '',
// 	'hostname' => 'localhost',
// 	'username' => 'postgres',
// 	'password' => 'vony',
// 	'database' => 'cms_site',
// 	'dbdriver' => 'postgre',
// 	'dbprefix' => '',
// 	'pconnect' => FALSE,
// 	'db_debug' => (ENVIRONMENT !== 'production'),
// 	'cache_on' => FALSE,
// 	'cachedir' => '',
// 	'char_set' => 'utf8',
// 	'dbcollat' => 'utf8_general_ci',
// 	'swap_pre' => '',
// 	'encrypt' => FALSE,
// 	'compress' => FALSE,
// 	'stricton' => FALSE,
// 	'failover' => array(),
// 	'save_queries' => TRUE,
// 	'port' => 5432
// );
